<template>
  <div><p>加入我们</p></div>
</template>

<script>
  export default {
    name: "join-us"
  }
</script>

<style scoped>

</style>
